import "../../css/widgets/widgets.css";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { seconds2HMS } from "../utils/utils";
function Times(props) {

    const { t } = useTranslation();
    const [loginTime, setLoginTime] = useState("00:00:00");
    const [pauseTime, setPauseTime] = useState("00:00:00");
    const [talkingTime, setTalkingTime] = useState("00:00:00");
    const [availableTime, setAvailableTime] = useState("00:00:00");
    useEffect(() => {
        let totalCallsDuration = 0;
        let pause = props.agent.pauseTime < 0 ? 0 : props.agent.pauseTime;
        //let wrapup = props.agent.wrapupTime < 0 ? 0 : props.agent.wrapupTime;
        let login = props.agent.loginTime < 0 ? 0 : props.agent.loginTime;

        if (props.agent.calls && props.agent.calls.length > 0)
            totalCallsDuration = props.agent.calls.map(x => x.duration).reduce((a, b) => a + b);

        if (props.agent.loginDate != null) {

            var loginDate = new Date(props.agent.loginDate);
            var now = new Date();
            var diff = Math.floor((now - loginDate) / 1000);

            login = props.agent.loginTime + diff;
        }

        var available = login - totalCallsDuration - props.agent.pauseTime - props.agent.wrapupTime;
        available = available < 0 ? 0 : available;

        setLoginTime(seconds2HMS(login));
        setPauseTime(seconds2HMS(pause));
        setTalkingTime(seconds2HMS(totalCallsDuration));
        setAvailableTime(seconds2HMS(available));

        return () => {
            // component unmounts
        };
    }, [props.agent]);


    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("clock")} /> {t("times")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col>
                        <div className="fs-2hx fw-bold text-gray-800">{loginTime}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("logintime")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{pauseTime}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("pausetime")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{talkingTime}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("talkingtime")}</div>
                    </Col>
                    <Col>
                        <div className="fs-2hx fw-bold text-gray-800">{availableTime}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("availabletime")}</div>
                    </Col>
                </Row>
                <Row>

                </Row>
            </div>
        </div>

    )
}
export default Times;